import { motion } from 'motion/react';

import { useMsgContent } from './useMsgContent';

import styles from './MessageContent.module.css';

export const MessageContent = ({
  content,
  setDelay,
  initDelay,
  duration,
  oneLineDuration,
}) => {
  const { contentRef, currentLine } = useMsgContent({
    content,
    setDelay,
    initDelay,
    duration,
    oneLineDuration,
  });

  return (
    <div className={styles.content} ref={contentRef}>
      <motion.div
        key={currentLine}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {currentLine}
      </motion.div>
    </div>
  );
};
